import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerGroup, RsCustomerGroupInfo, CustomerGroupAdd, CustomerGroupUpdate } from 'common/customers/services/types';

export type ICustomerGroupsDataProvider = IDataProviderV2<RsCustomerGroup, RsCustomerGroupInfo, CustomerGroupAdd, CustomerGroupUpdate>;

export class CustomerGroupsDataProvider
    extends AbstractDataProviderV2<RsCustomerGroup, RsCustomerGroupInfo, CustomerGroupAdd, CustomerGroupUpdate>
    implements ICustomerGroupsDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/groups');
    }
}
